module.exports = __webpack_public_path__ + "img/figure_5.9bce4923.svg";